module.exports = __webpack_public_path__ + "img/icon-pencil.7e95a3ea.svg";